const faqs = [
  {
    summary: "O que é o benefício TIM em parceria com a Thopen Energia?",
    details:
      "O benefício Thopen TIM é um programa da empresa Thopen, que permite aos clientes TIM Black, Controle e Pré Pago consumirem energia renovável das usinas gerenciadas pela Thopen. Essa parceria promove não apenas a sustentabilidade, mas também oferece uma forma prática de reduzir os custos com energia.",
  },
  {
    summary:
      "Quais clientes são elegíveis ao benefício TIM em parceria com a Thopen?",
    details:
      "O benefício é elegível para clientes dos planos TIM Black, Controle e Pré Pago (Individual e Família) das áreas atendidas e que possuem uma média de consumo da conta de luz de 350kwh nos últimos 12 meses.<br/>Para consultar a disponibilidade da sua região basta fazer a simulação de economia. O benefício ainda não está elegível para pessoas que estejam inadimplentes com a concessionária de energia, bem como aqueles que necessitem atendimento especial de fornecimento de energia como, por exemplo, respiradores",
  },
  {
    summary:
      "Como funciona o processo de geração de energia até o benefício na minha fatura?",
    details:
      "Ao aderir ao benefício Thopen -TIM, faremos a alteração da titularidade da conta de luz. Dessa forma você fará parte da Associação gerida pela Thopen.<br/> A Associação possui diversas usinas que entregam energia na distribuidora e ela é responsável por fazer chegar até a sua casa.",
  },
  {
    summary: "Haverá troca de titularidade da minha conta de energia?",
    details:
      "Sim, é feita a troca de titularidade para a Associação. Mas fique tranquilo, cuidamos disso tudo pra você! Com isso, a Thopen será responsável perante a distribuidora de energia. Mensalmente você receberá apenas a fatura da Thopen para pagamento.",
  },
  {
    summary: "Como posso aderir o benefício?",
    details:
      "O processo é bem simples! Você só precisa informar alguns dados e enviar sua conta de luz, junto com um documento com foto, à Thopen. Após uma análise, você receberá um termo de associação para assinar. A Thopen cuidará de todos os passos com a sua distribuidora de energia e em até 90 dias você já começará a ter economia na sua conta! Ah!, depois de alterada a titularidade, você receberá a 1ª fatura da Thopen ainda sem energia.",
  },
  {
    summary: "Como virá a minha fatura de energia?",
    details:
      "Como haverá a troca de titularidade, você não irá mais receber a conta de luz da distribuidora, ao invés disso, você receberá uma fatura de energia da Thopen, contendo todas as informações e a economia gerada pelo benefício Thopen TIM.",
  },
  {
    summary:
      "Em quanto tempo eu vou receber o benefício TIM em parceria com a Thopen Energia?",
    details:
      "Depois da assinatura do termos de adesão, leva de 60 a 90 dias para receber o 1º benefício.<br/> Você será avisado por e-mail quando o processo for concluído, e além disso pode consultar o andamento no Portal do Cliente a qualquer momento.<br/> Ah!, depois de alterada a titularidade, você receberá as primeiras faturas da Thopen ainda sem energia.",
  },
  {
    summary:
      "Em quanto tempo o benefício é refletido na minha conta após a aquisição?",
    details:
      "Como leva  de 60 a 90 dias para você receber o 1º benefício após a assinatura do contrato, as primeiras faturas ainda virão sem o benefício. Mas não se preocupe, o seu benefício virá no prazo estimado e você verá a economia na sua fatura",
  },
  {
    summary: "O que é geração distribuída?",
    details:
      "A Geração Distribuída é uma forma do consumidor gerar sua própria energia sem que necessariamente esteja no mesmo local, como acontece quando você gera a energia em seu telhado. <br/> Desta forma é permitido que o consumidor gere sua energia, desde que por fonte renovável, tais como solar, eólica, hídrica ou biogás, dentro da mesma área. <br/>Isso reduz a necessidade de grandes infraestruturas de transmissão, diminui as perdas de energia que ocorrem durante esse processo.",
  },
  {
    summary: "O que é energia injetada?",
    details:
      "É a energia gerada na usina que é injetada na rede da distribuidora. <br /><br />Essa energia abate seu consumo, subtraído de taxa de disponibilidade (consumo mínimo), taxa de iluminação (CIP) e impostos (ICMS e PIS/COFINS), gerando uma economia.",
  },
  {
    summary:
      "O que acontece se a energia gerada for maior do que a energia que consumi?",
    details:
      "Não se preocupe, você só paga pela energia que é possível ser compensada, ou seja, nunca mais do que você consumiu.",
  },
  {
    summary:
      "A conta de energia da minha residência precisa estar no meu nome para adquirir o benefício?",
    details:
      "Não precisa! Você pode conceder o seu benefício TIM a uma conta que esteja em outra titularidade, mas o titular da conta será o responsável pelo termo de adesão e pagamento mensal.<br/>Lembrando que cada cliente possui apenas 1 benefício.",
  },
  {
    summary: "Como faço para realizar alteração dos meus dados pessoais?",
    details:
      'Se você precisar alterar seus dados pessoais, como telefone ou e-mail,  é só falar com a gente pelos canais de atendimento da Thopen, seja por e-mail ou WhatsApp. <br/> <br/>  De Segunda a Sexta das 9:00 às 18:00. <br/> E-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a><br/>Whatsapp (11) 4863-3465',
  },
  {
    summary: "Posso adquirir o benefício para mais de uma residência? Quantos?",
    details:
      "Neste momento será possível apenas uma única conta de luz para 1 número TIM.",
  },
  {
    summary: "Mudei de endereço, o que eu faço?",
    details:
      'Mudou de endereço?  Avise a Thopen por e-mail ou WhatsApp. Para garantir uma transição suave, recomendamos que nos informe com pelo menos 90 dias de antecedência. Nós precisaremos retirar a conta de luz da titularidade da Associação. <br/> Se houver disponibilidade de energia para o novo endereço, iremos atualizar seus dados e solicitar a alteração de titularidade do novo endereço.<br/><br/>De Segunda a Sexta das 9:00 às 18:00.<br/>E-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a><br/>Whatsapp: (11) 4863-3465',
  },
  {
    summary: "Como fica a minha relação com a distribuidora de energia?",
    details:
      'Por lei cada área é servida por uma concessionária de distribuição de energia, então, a qualidade e a responsabilidade da entrega gerada continua sendo de responsabilidade da distribuidora que atende você hoje. <br/> Mas não se preocupe, a Thopen irá intermediar sua comunicação com a distribuidora.<br/> A Thopen possui atendimento  24 horas, todos os dias, você pode nos acionar por qualquer dos canais.<br/> De Segunda a Sexta das 9:00 às 18:00 <br/><br/> Atendimento emergencial 24 horas<br/> Whatsapp (11) 4863-3465<br/> e-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a>',
  },
  {
    summary: "Mudei de plano TIM, o que eu faço?",
    details:
      "A migração entre os planos TIM não afetará o recebimento do benefício.",
  },
  {
    summary: "Cancelei a minha linha de telefone TIM, o que eu faço?",
    details:
      'Você perderá o benefício TIM e sua economia será reduzida em 50%.<br/>Se desejar, poderá entrar em contato com a Thopen e solicitar o cancelamento do benefício.<br/>A solicitação pode ser feita por qualquer dos canais de atendimento.<br/><br/>De Segunda a Sexta das 9:00 às 18:00<br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a>',
  },
  {
    summary: "Se eu ficar sem energia, o que eu faço?",
    details:
      'Você pode comunicar a falta de energia à Thopen por ligação ou WhatsApp <br/><br/> De Segunda a Sexta das 9:00 às 18:00 <br/>Atendimento emergencial 24 horas<br/>Whatsapp: (11) 4863-3465 <br/>e-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a>',
  },
  {
    summary: "A economia que tenho é diferente todos os meses, qual motivo?",
    details:
      "A economia varia porque acompanha o consumo mensal e a energia injetada. Lembre-se que, através da associação, à Thopen você passa a gerar parte de sua própria energia, a qual abate o seu consumo de energia. <br/> Alguns custos não podem ser abatidos, como taxa de disponibilidade (consumo mínimo), taxa de iluminação (CIP) e impostos, como PIS/COFINS e ICMS (que varia mensalmente).",
  },
  {
    summary: "Como vou receber minha conta de energia?",
    details:
      'Você irá receber mensalmente a fatura da Thopen por e-mail ou poderá retirar uma via no Portal do Cliente,  pagina da Thopen (<a href="https://thopenergy.com.br/tim" target="_blank">www.thopenergy.com.br/tim</a>). <br/><br/>De Segunda a Sexta das 9:00 às 18:00 <br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href="mailto:sac@thopenergy.com.br">sac@thopenergy.com.br</a>',
  },
  {
    summary: "Receberei quantas faturas? ",
    details:
      "A partir da adesão ao Benefício Thopen TIM, você receberá apenas uma fatura, a da Thopen. <br/>As primeiras faturas ainda serão emitidas sem o benefício, mas não se preocupe que dentro do prazo você já irá usufruir.",
  },
  {
    summary:
      "Tenho dúvidas sobre a composição da minha fatura, onde consigo tira-las?",
    details:
      "Você receberá um e-mail explicando a fatura, antes de receber a primeira. Mas poderá a qualquer momento solicitar esclarecimentos através dos canais de atendimento Thopen, e-mail ou WhatsApp. <br/>Além disso, temos um tutorial de 'entenda sua fatura' disponível para consulta. (inserir link) <br/><br/>De Segunda a Sexta das 9:00 às 18:00 <br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href='mailto:sac@thopenergy.com.br'>sac@thopenergy.com.br</a>",
  },
  {
    summary: "Não concordo com o valor, como realizo a contestação da conta?",
    details:
      "Você poderá enviar um e-mail ou WhatsApp para a Thopen solicitando esclarecimentos dos valores faturados.<br/><br/>De Segunda a Sexta das 9:00 às 18:00<br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href='mailto:sac@thopenergy.com.br'>sac@thopenergy.com.br</a>",
  },
  {
    summary:
      "Realizei o pagamento da minha conta de energia Thopen Energia e continuo sendo cobrada, como posso resolver?",
    details:
      "Você deve entrar em contato com a Thopen pelo e-mail ou WhatsApp. Identificado o pagamento, será baixada a cobrança. <br/><br/>De Segunda a Sexta das 9:00 às 18:00<br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href='mailto:sac@thopenergy.com.br'>sac@thopenergy.com.br</a>",
  },
  {
    summary:
      "Realizei o pagamento em duplicidade e gostaria de entender como devo seguir?",
    details:
      "Se houver pagamento em duplicidade, entre em contato com a Thopen e o valor será creditado em sua próxima fatura. <br/><br/>  De Segunda a Sexta das 9:00 às 18:00<br/> Atendimento emergencial 24 horas<br/> Whatsapp (11) 4863-3465<br/> e-mail: <a href='mailto:sac@thopenergy.com.br'>sac@thopenergy.com.br</a>",
  },
  {
    summary: "Como faço para realizar o encerramento do contrato?",
    details:
      "Para encerrar seu contrato, é bem fácil! Você pode fazer isso através dos canais de atendimento da Thopen, como e-mail ou WhatsApp. Também é possível realizar a solicitação pelo Portal do Cliente.<br/><br/>Thopen irá comunicar a distribuidora e em até 45 dias você receberá a fatura final e confirmação de troca de titularidade.<br/>De Segunda a Sexta das 9:00 às 18:00<br/>Atendimento emergencial 24 horas<br/>Whatsapp (11) 4863-3465<br/>e-mail: <a href='mailto:sac@thopenergy.com.br'>sac@thopenergy.com.br</a>",
  },
  {
    summary: "Qual prazo para cancelamento do contrato?",
    details:
      "Após sua solicitação comunicaremos a distribuidora e em até 45 dias você receberá a fatura final e confirmação de troca de titularidade. <br/> Depois disso, você voltará a receber sua conta de luz diretamente da distribuidora.",
  },
  {
    summary: "Tenho algum custo para cancelar?",
    details: "Não existe custo para cancelamento.",
  },
];

export default faqs;
